/*
 *  Class Sitemenu
 */
export
default class Sitemenu {
    constructor() {
        this.menus = document.querySelectorAll('.js-sitemenu');
    }

    toggleMenu(e) {
        const li = e.target.closest('li');
        if (li.querySelector('ul')) {
            e.preventDefault();
            li.classList.toggle('active');
        }
    }

    init() {
        for (let i = 0; i < this.menus.length; i++) {
            const items = this.menus[i].querySelectorAll('li > a');
            for (let ii = 0; ii < items.length; ii++) {
                items[ii].addEventListener('click', this.toggleMenu.bind(this));
            }
        }
    }
}
